export const consentCategories = [
  {
    id: "necessary",
    name: "Notwendig",
    description:
      "Diese Cookies sind für die Grundfunktionalität der Website erforderlich und können nicht deaktiviert werden. Sie speichern z.B. Ihre Zustimmung zu den Cookie-Einstellungen.",
    isMandatory: true,
  },
  {
    id: "analytics_storage",
    name: "Analyse",
    description:
      "Diese Cookies ermöglichen es uns, die Nutzung der Website zu analysieren, um die Leistung zu messen und zu verbessern. (z.B. Google Analytics)",
    isMandatory: false,
  },
  {
    id: "ad_storage",
    name: "Marketing & Werbung",
    description:
      "Diese Cookies werden verwendet, um Ihnen relevantere Werbung anzuzeigen und den Erfolg unserer Werbekampagnen zu messen. (z.B. Google Ads)",
    isMandatory: false,
  },
  // Fügen Sie hier bei Bedarf weitere Kategorien hinzu, z.B.:
  // {
  //   id: 'ad_user_data',
  //   name: 'Personalisierte Werbung',
  //   ...
  // },
  // {
  //   id: 'ad_personalization',
  //   name: 'Werbe-Personalisierung',
  //   ...
  // }
];
